import * as R from 'ramda';
export var getValue = function getValue(labelAccessor) {
  return function (item) {
    return R.has('values', item) ? R.reduce(function (acc, val) {
      return {
        label: acc.label,
        id: R.isEmpty(acc.id) ? val.id : acc.id + ', ' + val.id,
        flags: R.concat(acc.flags, val.flags || []),
        parents: R.concat(acc.parents, val.parents || [])
      };
    }, {
      id: '',
      flags: [],
      parents: [],
      label: labelAccessor(item.values)
    }, item.values) : R.pipe(R.prop('value'), function (val) {
      return R.assoc('label', labelAccessor(val), val);
    })(item);
  };
};
export var defaultLabelAccessor = function defaultLabelAccessor(item) {
  if (R.is(Object, item)) {
    return R.prop('name', item);
  }
  return R.pipe(R.pluck('name'), R.join(', '))(item);
};